module.exports = __webpack_public_path__ + "static/media/teacherImg.fc3e049b.png";